import React from 'react';
import './Row.scss';
import { classNameBuilder } from '../../utils/className';

interface IProps {
    color?: 'dark-blue' | 'grey' | 'white';
    typeContainer?: 'image' | 'common' | 'disabled';
}

const Row: React.FC<React.PropsWithChildren<IProps>> = ({
    children,
    color = 'dark-blue',
    typeContainer,
}) => {
    const cn = classNameBuilder('row');
    const mod = {
        typeContainer: typeContainer || 'common',
        color: color || 'dark-blue',
    };

    return <div className={cn(mod)}>{children}</div>;
};

export default Row;
